export default {
  title: 'Notifications',
  loading: 'Chargement...',
  noNotifications: 'Aucune notification',
  loadMore: 'Charger plus de notifications',
  ViewAllNotifications: 'Voir toutes mes notifications',
  serviceCategoryApprovalError: "Erreur lors de l'approbation de la catégorie de service",
  serviceCategoryApproved:
    'La catégorie de service a été approuvée et est maintenant visible par tous les utilisateurs.',
  industryApprovalError: "Erreur lors de l'approbation du secteur d'activité",
  industryApproved:
    "Le secteur d'activité a été approuvé et est maintenant visible par tous les utilisateurs.",
  button: {
    manageAlliances: 'Gérer mes alliances',
    view: 'Voir',
    manageWallet: 'Gérer mon Porte-monnaie',
    viewDetails: 'Voir les détails',
    viewProspects: 'Voir mes contacts',
    viewJobs: 'Voir mes projets',
    viewSubmissions: 'Voir mes soumissions',
    viewProjects: 'Voir mes projets',
    viewAdjustment: "Voir l'ajustement",
    viewProject: 'Voir le projet',
    viewJob: 'Voir le projet',
    viewSubmission: 'Voir la soumission',
    viewQuoteRequest: 'Voir la demande de soumission',
    viewHub: 'Voir les détails',
    approveAndMakeVisibleForAll: 'Approuver et rendre disponible pour tout le monde',
  },
  message: {
    alliance_accepted: "{{name}} a accepté votre demande d'alliance",
    alliance_rejected: "{{name}} a décliné votre demande d'alliance",
    alliance_created: "{{name}} vous a envoyé une demande d'alliance",
    alliance_re_requested: "{{name}} vous a renvoyé une demande d'alliance",
    alliance_retired: '{{name}} a mis fin à votre alliance',
    quote_request_received: '{{name}} vous a envoyé une demande de soumission',
    quote_request_accepted: '{{name}} a accepté votre demande de soumission',
    quote_request_rejected: '{{name}} a décliné votre demande de soumission',
    job_cancelled: '{{name}} a retiré son projet',
    adjustment_submitted: '{{name}} a envoyé un ajustement pour votre soumission',
    quote_alliance_invited: '{{name}} vous a invité à participer à leur soumission',
    quote_alliance_accepted: '{{name}} a accepté votre invitation à participer à votre soumission',
    quote_alliance_rejected: '{{name}} a décliné votre invitation à participer à votre soumission',
    quote_alliance_retired: "{{name}} vous a retiré d'une soumission",
    quote_alliance_retired_by_alliance: '{{name}} a retiré sa soumission',
    new_job_posted: '{{name}} a publié un projet qui pourrait vous intéresser',
    quote_submitted: '{{name}} a envoyé une soumission pour votre projet',
    child_quote_submitted: '{{name}} a soumis sa partie du dévis de votre collaboration',
    parent_quote_submitted: '{{name}} a soumis le dévis de votre collaboration au client',
    quote_change_requested: '{{name}} a demandé des modifications à votre soumission',
    quote_accepted: '{{name}} a accepté votre soumission',
    parent_quote_accepted: '{{name}} a accepté votre soumission via une collaboration',
    quote_rejected: '{{name}} a rejeté votre soumission',
    parent_quote_rejected: '{{name}} a rejeté votre soumission via une collaboration',
    quote_not_accepted: "{{name}} n'a pas retenu votre soumission",
    parent_quote_not_accepted: "{{name}} n'a pas retenu votre soumission via une collaboration",
    project_status_updated: '{{name}} a modifié le statut de votre projet',
    new_contact_added: '{{name}} fait désormais partie de vos contacts',
    project_completed: '{{name}} a marqué votre projet {{project}} comme terminé',
    project_cancelled: '{{name}} a annulé votre projet {{project}}',
    new_report_submitted: '{{name}} a soumis un nouveau signalement',
    new_industry_suggested: '{{name}} a suggeré un nouveau domaine',
    new_service_category_suggested: '{{name}} a suggeré un nouveau service',
    job_expiring_soon:
      'Votre projet « {{jobTitle}} » expirera bientôt — renouvelez-le gratuitement',
    job_expired:
      "Votre projet « {{jobTitle}} » n'accepte plus de nouvelles offres — renouvelez-le gratuitement",
    job_expired_hasApplicants:
      "Votre projet « {{jobTitle}} » n'accepte plus de nouvelles offres — renouvelez-le gratuitement, ou passez son statut à « En révision des soumissions » pour prévenir les pigistes qui ont soumis une offre.",
    job_removal_warning:
      'Votre projet « {{jobTitle}} » sera bientôt retiré du babillard — renouvelez-le gratuitement',
    job_removed: 'Votre projet « {{jobTitle}} » a été retiré du babillard',
    job_expired_for_applicant:
      "Le projet « {{jobTitle}} » n'accepte plus de nouvelles offres. Vous n'avez pas eu l'occasion de terminer votre soumission.",
    job_renewed_for_applicant:
      'Le projet « {{jobTitle}} » est de nouveau actif et accepte les offres',
    job_selection_period_started:
      'Votre projet « {{jobTitle}} » est maintenant en révision des soumissions — les pigistes ayant soumis une offre en ont été informés.',
    job_selection_period_started_for_applicant:
      'Le recruteur du projet « {{jobTitle}} » a commencé à réviser les soumissions reçues. Attendez-vous à une réponse bientôt.',
    hub_message: '{{name}} vous a envoyé un message',
    hub_message_attachment: '{{name}} a partagé un document avec vous',
    credits_gifted_manual: '{{name}} a ajouté {{amount}} crédits à votre compte',
    credits_gifted_monthly: 'Vos {{amount}} crédits mensuels ont été ajoutés à votre compte',
    job_edited_by_admin: 'Un administrateur a modifié votre projet « {{jobTitle}} »',
    job_unpublished_by_admin: 'Un administrateur a dépublié votre projet « {{jobTitle}} »',
    job_paused_by_admin: 'Un administrateur a mis en pause votre projet « {{jobTitle}} »',
    job_assigned_by_admin: 'Un administrateur vous a assigné le projet « {{jobTitle}} »',
    welcome: 'Bienvenue sur Nous Pigeons!',
    fallback: 'Vous avez une nouvelle notification',
  },
  first_name_fallback: "Quelqu'un",
  alliance_rejected_modal: {
    title: "{{name}} a decliné votre demande d'alliance",
    subTitle: 'Message de <bold>{{name}}</bold>',
  },
  quote_request_rejected_modal: {
    title: '{{name}} a décliné votre demande de soumission',
    subTitle: 'Message de <bold>{{name}}</bold>',
  },
  quote_alliance_rejected_modal: {
    title: '{{name}} a décliné votre invitation à participer à votre soumission',
    subTitle: 'Message de <bold>{{name}}</bold>',
  },
  job_moderated_by_admin_modal: {
    subTitle: "Motif de l'administrateur",
  },
  quote_request_change_modal: {
    title: "{{name}} vous a envoyé une demande d'ajustement",
    subTitle: 'Message de <bold>{{name}}</bold>',
  },
  quote_rejected_modal: {
    title: '{{name}} a rejeté votre soumission',
    subTitle: 'Raison du rejet',
    default_message:
      'Votre soumission a été rejetée car le projet est soit annulé soit le propriétaire du projet a accepté une autre soumission.',
  },
  new_service_category_suggested_modal: {
    title: '{{name}} a proposé une nouvelle catégorie de service',
    subTitle: 'la nouvelle catégorie de service :',
  },
  new_industry_suggested_modal: {
    title: "{{name}} a proposé un nouveau secteur d'activité",
    subTitle: "Le nouveau secteur d'activité :",
  },
  new_report_submitted_modal: {
    title: '{{name}} a soumis un nouveau signalement',
    subTitle: 'Le nouveau signalemeent :',
  },
  adjustment_submitted_modal: {
    title: '{{name}} a soumis un ajustement',
    subTitle: 'suite à votre demande :',
  },
  close: 'Fermer',
} as const;
